/* eslint-disable max-len */
import GEN from '../../../../assets/general.png';

import {API_ENDPOINT_JSON} from './../../../../config';
import {
  activitiesAndWorkersTabQuestions,
  foundationTabQuestions,
  governanceTabQuestions,
  organizationalProfileTabQuestions,
  stakeholderEngagementTabQuestions,
  strategyPoliciesAndPracticesTabQuestions
} from './generalTabs';

export const general = {
  header: {
    imageUrl: GEN,
    title: 'General',
    description: `Pertains to the evaluation criteria measuring a company's
      environmental, social, and governance performance concerning
       sustainable and ethical practices.`,
    noOfModules: 6,
    answeredQuestions: 16,
    totalQuestions: 65
  },
  APIRoute: API_ENDPOINT_JSON.ESG.GRI.general,
  tabs: [
    {
      id: 'foundation',
      title: 'Foundation',
      questions: foundationTabQuestions
    },
    {
      id: 'organizationalProfile',
      title: 'Organizational profile',
      questions: organizationalProfileTabQuestions
    },
    {
      id: 'activitiesAndWorkers',
      title: 'Activities and workers',
      questions: activitiesAndWorkersTabQuestions
    },
    {
      id: 'governance',
      title: 'Governance',
      questions: governanceTabQuestions
    },
    {
      id: 'strategyPoliciesAndPractices',
      title: 'Strategy, policies and practices',
      questions: strategyPoliciesAndPracticesTabQuestions
    },
    {
      id: 'stakeholderEngagement',
      title: 'Stakeholder engagement',
      questions: stakeholderEngagementTabQuestions
    }
  ]
};
